import type { KpiSummary } from './clientKpis'
import type { ClientDashboardCadence } from '@platform/shared'

export type Cadence = ClientDashboardCadence

export const CADENCE_LABELS: Record<Cadence, string> = {
  weekly: 'Weekly',
  fortnightly: 'Fortnightly',
  monthly: 'Monthly',
  quarterly: 'Quarterly',
  sixMonthly: 'Six-monthly',
  yearly: 'Yearly',
}

export interface AccountTeamMember {
  _id: string
  name?: string
  email?: string
  picture?: string
  onSupportTeam: boolean
}

export interface ClientDashboard {
  _id: string
  companyId: string
  companyName: string
  companyDeleted: boolean
  clientTrackerEnabled: boolean
  accountTeam: AccountTeamMember[]
  cadence: Cadence | null
  nextCallAt: string | null
  lastCallAt: string | null
  updatedAt: string
  kpiSummary?: KpiSummary | null
}

export interface EligibleCompany {
  _id: string
  name: string
}

export interface ClientDashboardChanges {
  accountTeamUserIds?: string[]
  cadence?: Cadence | null
  nextCallAt?: string | null
}

export const memberName = (member: AccountTeamMember) => member.name || member.email || 'Unknown user'

export type TicketGroup = 'queue' | 'tracker-help-desk' | 'tracker-manual'

export const TICKET_GROUP_LABELS: Record<TicketGroup, string> = {
  queue: 'Queue only',
  'tracker-help-desk': 'Tracker: from help desk',
  'tracker-manual': 'Tracker: added manually',
}

export interface HelpDeskCounts {
  raised: number
  open: number
  onHold: number
  completed: number
}

export interface HelpDeskTicketRow {
  _id: string
  refNumber?: number
  subject: string
  status: string
  group: TicketGroup
  type: string | null
  productArea: string | null
  createdAt: string
  completedAt: string | null
  requesterName: string | null
}

export interface HelpDeskHealth {
  period: { from: string; to: string }
  totals: HelpDeskCounts
  byGroup: Record<TicketGroup, HelpDeskCounts>
  medianFirstReplyMinutes: number | null
  medianCompleteMinutes: number | null
  tracker: { total: number; completed: number }
  byType: { type: string | null; count: number }[]
  byArea: { productArea: string | null; count: number; information: number }[]
  perMonth: { month: string; byType: Record<string, number> }[]
  oldestOpen: { _id: string; subject: string; createdAt: string } | null
  tickets: HelpDeskTicketRow[]
}

export type HelpDeskPeriod = '3m' | '12m' | 'all'
